import React from 'react';
export function SampleTasks() {
  const sampleTasks = [{
    title: 'Eloquent Query Optimization',
    level: 'Senior Level',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/u9DNMo9UJzsSmoN1mWxsX8/Schermafbeelding_2025-10-13_165921.png'
  }, {
    title: 'Service Providers',
    level: 'Senior Level',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xm2QDJxdPhWWZknmdugZ4a/Schermafbeelding_2025-10-13_170000.png'
  }, {
    title: 'Testing',
    level: 'Senior Level',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qeT9sciNsddp3PNFXNskWX/Schermafbeelding_2025-10-13_170129.png'
  }];
  return <section id="sample" className="py-12 md:py-20 bg-gray-50" data-id="element-320">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-321">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-3 sm:mb-4" data-id="element-322">
          What Do Laravel Test Questions Look Like?
        </h2>
        <p className="text-sm sm:text-base text-center text-gray-600 mb-8 sm:mb-12 max-w-2xl mx-auto px-4" data-id="element-323">
          Each test contains 45 multiple-choice questions with real code
          snippets. Here's a preview of the types of challenges candidates will
          face.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-324">
          {sampleTasks.map((task, index) => <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200" data-id="element-325">
              <div className="p-4 sm:p-5 border-b border-gray-200" data-id="element-326">
                <h3 className="font-semibold text-base sm:text-lg" data-id="element-327">
                  {task.title}
                </h3>
                <span className="text-xs sm:text-sm text-gray-500" data-id="element-328">
                  {task.level}
                </span>
              </div>
              <div className="p-4 sm:p-5 relative" data-id="element-329">
                <div className="overflow-hidden h-36 sm:h-44 relative" data-id="element-330">
                  <img src={task.imageUrl} alt={`${task.title} code example`} className="w-full h-auto rounded border border-gray-100" data-id="element-331" />
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-8 sm:mt-12 text-center" data-id="element-332">
          <a href="https://certificationforlaravel.testportal.com/test.html?t=Xj7qVzGX8p3c" className="px-6 py-3 bg-primary text-white rounded-2xl hover:bg-primary/90 transition-colors inline-block font-medium text-sm sm:text-base" data-id="element-333">
            Try a Sample Test
          </a>
        </div>
      </div>
    </section>;
}